var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"student-search-alert-error d-flex items-align-center",class:_vm.customClasses},[_c('div',{staticClass:"w-100 text-left"},[(_vm.message)?_c('div',{staticClass:"d-inline"},[_c('em',{class:_vm.iconClass})]):_vm._e(),_c('p',{staticClass:"text-left d-inline",domProps:{"innerHTML":_vm._s(_vm.message)}}),_vm._t("action-text")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }